import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Trans } from "react-i18next";
import TableContainer from "../../../components/Tables/TableContainer";
import {
  Fragment,
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useMediaQuery } from "@mui/material";
import { useTranslationApp } from "../../../lib/i18next";
import { useDispatchApp } from "../../../lib/redux";
import { useNavigate } from "react-router-dom";
import { startGetAdsUser } from "../../../actions/user";
import {
  getGeneralStatistics,
  getStatusAdsCampaign,
} from "../../../services/adsCampaigns";
import {
  getAlertMessage as getCampaignAlertMessage,
  getCreativeFatigueLevel,
  isAlertForActiveItem,
  isVisibleCreativeFatigueAlert,
} from "../../../utils/campaignAlerts";
import useCampaignAlertItemStatuses from "../../../hooks/useCampaignAlertItemStatuses";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "../../../components/Form/TextField";
import { useForm } from "react-hook-form";
import {
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ALERTS_CAMPAIGNS,
  ALERTS_CAMPAIGNS_TEXT_TABLE,
  META,
  SORT_DIRECTION,
  SORTABLE_COLUMNS,
  STATUS_SORT_ORDER,
  DEFAULT_SORT_CONFIG,
  YELLOW_ALERT_TYPES,
  ALERT_COLORS,
  CREATIVE_FATIGUE_ALERT_TYPE,
  CREATIVE_FATIGUE_LEVELS,
  GALLERY_DRAG_MIME_SELECTED,
} from "../../../utils/constants";
import { KPI_TARGET_CPA_ABOVE_PLATFORM } from "../../../i18n/keysTranslations";
import { numberMetricFormat } from "../../../utils/numbers";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useFolderAwareDeleteAction } from "../../../hooks/useFolderAwareDeleteAction";
import useSlideMenuCollapsed from "../../../hooks/useSlideMenuCollapsed";
import {
  Avatar,
  Stack,
  IconButton,
  Tooltip,
  TableBody,
  TableHead,
  TableRow,
  Chip,
  TableSortLabel,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import SelectUser from "../../../components/Form/SelectUser";
import ColumnVisibilityMenu from "./ColumnVisibilityMenu";
import { PILL_TRIGGER_VARIANT } from "../../../components/Buttons/PillTriggerButton";
import Button from "../../../components/Buttons/Button";
import {
  CAMPAIGNS_TABLE_ARIA_LABEL,
  CAMPAIGNS_TABLE_COLLAPSE_ROW,
  CAMPAIGNS_TABLE_EXPAND_ROW,
  COLUMN_NAME_ACTIONS,
  COLUMN_NAME_CAMPAIGN,
  COLUMN_NAME_CLICKS,
  COLUMN_NAME_CREATED_BY,
  COLUMN_NAME_PLATFORM,
  COLUMN_NAME_RESULTS,
  COLUMN_NAME_STATUS,
  DATE_SHORT_2,
  EMPTY_CAMPAIGNS,
  COLUMN_NAME_CREATED_DATE,
  LOADING,
  ALERT_ARCHIVE_CAMPAIGN_TITLE,
  ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION,
  BUTTON_ARCHIVE_CAMPAIGN,
  COLUMN_NAME_CTR,
  COLUMN_NAME_IMPRESSIONS,
  COLUMN_NAME_CPA,
  COLUMN_NAME_CPM,
  COLUMN_NAME_CPC,
  COLUMN_NAME_SPEND,
  ROAS_METRICS,
  FREQUENCY,
  REPORTS,
  VALUE_NUMBER,
  FILTER_BY_USERS_PLACEHOLDER,
  ALL_USERS,
  LIST_TABLE_CAMPAIGNS_TITLE,
  CAMPAIGN,
  CAMPAIGNS,
  ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE,
  CAMPAIGNS_SEARCHBAR_PLACEHOLDER,
  CAMPAIGNS_NOT_FOUND,
  CAMPAIGNS_FOLDER_EMPTY,
  CAMPAIGNS_FOLDERS_MOVE,
} from "../../../i18n/keysTranslations";
import {
  getCurrencyAdAccountPlatform,
  getRoleCapability,
} from "../../../actions/getters";
import {
  startDeleteAdsCampaign,
  startSearchAdsCampaignsByName,
} from "../../../actions/adsCampaigns";
import {
  getFormattedCampaign,
  logoPlatform,
  openLink,
} from "../../../utils/string";
import {
  getUniqueID,
  numberCompactFormat,
  numberDecimal,
} from "../../../utils/numbers";
import { ConfirmAlert } from "../../../components/Alerts/Alerts";
import ButtonDuplicateCampaign from "../../../components/Buttons/ButtonDuplicateCampaign";
import StatusSwitch from "./StatusSwitch";
import CampaignTableExpandButton from "./campaignTableTree/CampaignTableExpandButton";
import CampaignTableTreeRows from "./campaignTableTree/CampaignTableTreeRows";
import useCampaignTableTree from "./campaignTableTree/useCampaignTableTree";
import { buildCampaignEditorPath } from "./campaignTableTree/campaignTableTree";
import Loader from "../../../components/Loaders/Loader";
import _ from "lodash";
import { ChartColumnBig } from "lucide-react";
import CellTypography from "../../../components/Tables/CellTypography";
import TableCell from "../../BillingAndPayments/components/TableCell";
import { BOX_SHADOW_FIELDS, INPUT_COLOR_BORDER } from "../../../utils/colors";
import CampaignStatisticsOverview from "../../../components/Statistics/CampaignStatisticsOverview";
import {
  commonPropsTableCellBody,
  commonPropsTableCellHeader,
  SkeletonCampaignMetric,
} from "../../../components/Tables/campaignsTableShared";

const MIN_LENGTH_TO_SEARCH = 3;
const FOLDER_BAR_STICKY_TOP_PX = 105;

const AdsCampaignsFolderBarSticky = ({ children }) => {
  const sentinelRef = useRef(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsStuck(!entry.isIntersecting);
      },
      {
        threshold: [0, 1],
        rootMargin: `-${FOLDER_BAR_STICKY_TOP_PX}px 0px 0px 0px`,
      }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Box
        ref={sentinelRef}
        aria-hidden
        sx={{
          height: "1px",
          mb: -1,
          pointerEvents: "none",
          visibility: "hidden",
        }}
      />
      <Box
        sx={{
          position: "sticky",
          top: `${FOLDER_BAR_STICKY_TOP_PX}px`,
          zIndex: 1100,
          bgcolor: "#fcfcfc",
          borderBottom: "1px solid",
          borderColor: isStuck ? INPUT_COLOR_BORDER : "transparent",
          transition: "border-color 180ms ease",
          mx: { xs: -4.5, md: -5 },
          px: { xs: 4.5, md: 5 },
          mb: -1,
        }}
      >
        {children}
      </Box>
    </>
  );
};

// Utility functions for sorting
const getPlatformSortValue = (platforms) =>
  platforms?.join(",").toLowerCase() || "";

const getStatusSortValue = (status) => STATUS_SORT_ORDER[status] || 0;

const getStatisticsValue = (statistics, key) => {
  const stats = getGeneralStatistics(statistics || {});
  return Number(stats[key]) || 0;
};

const AdsCampaignsTable = ({
  data = {},
  loading,
  onChangeStatusCampaign = () => {},
  lastItemRef,
  loadedLastCampaign,
  columnVisibility,
  onToggleColumn,
  onSetColumnVisibility,
  statisticsLoading = [],
  control,
  sortConfig = DEFAULT_SORT_CONFIG,
  onTableSort = () => {},
  hasActiveDateRange = false,
  dateRange = null, // { startDate, endDate } o null para métricas totales
  syncingCampaignIDs = [],
  folderCampaignIDs = null,
  membershipRevision = 0,
  folderID = null,
  selectedCampaignIDs = [],
  onToggleCampaignSelection = () => {},
  canEditFolders = false,
  onOpenMoveFolder = () => {},
  onRemoveFromFolder = () => {},
  folderBar = null,
}) => {
  const { t, i18n } = useTranslationApp();
  const dispatch = useDispatchApp();
  const navigate = useNavigate();
  const { drawerWidth, widthTransition } = useSlideMenuCollapsed();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const statusColumnWidth = i18n.language?.startsWith("en") ? 100 : 120;
  const alertColumnWidth = 18;

  const [users, setUsers] = useState({});
  const [isDeletingCampaign, setIsDeletingCampaign] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState({});
  const [isSearching, setIsSearching] = useState(false);
  const [localSortConfig, setLocalSortConfig] = useState(null);

  const { control: searchControl } = useForm({
    defaultValues: {
      searchCampaigns: "",
    },
  });
  const campaignsForAlertStatus = useMemo(
    () => ({ ...(data || {}), ...(searchResults || {}) }),
    [data, searchResults]
  );
  const alertItemStatuses = useCampaignAlertItemStatuses(
    campaignsForAlertStatus
  );

  const canEditCampaign = dispatch(getRoleCapability("canEditCampaign"));
  const canCreateCampaign = dispatch(getRoleCapability("canCreateCampaign"));
  const {
    expanded: expandedCampaignTrees,
    entries: campaignTreeEntries,
    onToggleCampaignTree,
    onRetryCampaignTree,
    onChangeEntityStatus,
  } = useCampaignTableTree({ dateRange });

  const onRunRemoteSearch = useCallback(
    async (term) => {
      if (!term || term.length < MIN_LENGTH_TO_SEARCH) {
        setSearchResults({});
        setIsSearching(false);
        return;
      }
      setIsSearching(true);

      const response = await dispatch(
        startSearchAdsCampaignsByName({
          name: term,
          minLength: MIN_LENGTH_TO_SEARCH,
        })
      );
      if (response?.ok) {
        const results = response.data || {};
        if (!folderCampaignIDs) {
          setSearchResults(results);
        } else {
          const allowedIDs = new Set(folderCampaignIDs);
          const filtered = {};
          Object.keys(results).forEach((campaignID) => {
            if (allowedIDs.has(campaignID)) {
              filtered[campaignID] = results[campaignID];
            }
          });
          setSearchResults(filtered);
        }
      } else {
        setSearchResults({});
      }
      setIsSearching(false);
    },
    [dispatch, folderCampaignIDs]
  );

  // Inline debounce implementation (no additional imports)
  const debouncedSearchRef = useRef(null);
  useEffect(() => {
    if (debouncedSearchRef.current) {
      clearTimeout(debouncedSearchRef.current);
    }
    if (searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
      setSearchResults({});
      setLocalSortConfig(null);
    }
    debouncedSearchRef.current = setTimeout(() => {
      onRunRemoteSearch(searchTerm);
    }, 500);
    return () => clearTimeout(debouncedSearchRef.current);
  }, [searchTerm, onRunRemoteSearch]);

  const searchSortActive =
    !!searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH;
  const effectiveSortConfig =
    searchSortActive && localSortConfig ? localSortConfig : sortConfig;

  const SortableHeader = ({
    columnKey,
    children,
    sx,
    stickyPosition,
    stickyOffset,
    ...props
  }) => (
    <TableCell
      {...commonPropsTableCellHeader}
      sx={sx}
      sortDirection={
        effectiveSortConfig.key === columnKey
          ? effectiveSortConfig.direction
          : false
      }
      stickyPosition={stickyPosition}
      stickyOffset={stickyOffset}
      {...props}
    >
      <TableSortLabel
        active={effectiveSortConfig.key === columnKey}
        direction={
          effectiveSortConfig.key === columnKey
            ? effectiveSortConfig.direction
            : SORT_DIRECTION.ASC
        }
        onClick={() => {
          const searchActiveNow = !!(
            searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH
          );
          if (searchActiveNow) {
            const current = localSortConfig || sortConfig;
            const nextDirection =
              current.key === columnKey &&
              current.direction === SORT_DIRECTION.DESC
                ? SORT_DIRECTION.ASC
                : SORT_DIRECTION.DESC;
            setLocalSortConfig({ key: columnKey, direction: nextDirection });
            return;
          }
          onTableSort(columnKey);
        }}
        sx={{
          ".MuiTableSortLabel-icon": {
            fontSize: 15,
          },
        }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );

  // Optimized sort value getter
  const getSortValue = useCallback(
    (campaign, columnKey) => {
      const sortValueMap = {
        [SORTABLE_COLUMNS.CAMPAIGN]: () =>
          (
            campaign?.platformsData?.[campaign?.platforms?.[0]]?.name ||
            campaign.name ||
            ""
          ).toLowerCase(),

        [SORTABLE_COLUMNS.PLATFORM]: () =>
          getPlatformSortValue(campaign.platforms),

        [SORTABLE_COLUMNS.CREATED_BY]: () =>
          (users[campaign.createdBy]?.name || "").toLowerCase(),

        [SORTABLE_COLUMNS.CREATION_TIME]: () => campaign.creationTime || 0,

        [SORTABLE_COLUMNS.IMPRESSIONS]: () =>
          getStatisticsValue(campaign.statistics, "impressions"),

        [SORTABLE_COLUMNS.CLICKS]: () =>
          getStatisticsValue(campaign.statistics, "click"),

        [SORTABLE_COLUMNS.CTR]: () =>
          getStatisticsValue(campaign.statistics, "ctr"),

        [SORTABLE_COLUMNS.SPEND]: () =>
          getStatisticsValue(campaign.statistics, "spend"),

        [SORTABLE_COLUMNS.ROAS]: () =>
          getStatisticsValue(campaign.statistics, "roas"),

        [SORTABLE_COLUMNS.CPM]: () =>
          getStatisticsValue(campaign.statistics, "cpm"),

        [SORTABLE_COLUMNS.CPC]: () =>
          getStatisticsValue(campaign.statistics, "cpc"),

        [SORTABLE_COLUMNS.RESULTS]: () =>
          getStatisticsValue(campaign.statistics, "mainAction"),

        [SORTABLE_COLUMNS.CPA]: () =>
          getStatisticsValue(campaign.statistics, "costPerMainAction"),

        [SORTABLE_COLUMNS.FREQUENCY]: () =>
          getStatisticsValue(campaign.statistics, "frequency"),

        [SORTABLE_COLUMNS.STATUS]: () => {
          const status = getStatusAdsCampaign({
            states: campaign.states,
            target: "general",
          });
          return getStatusSortValue(status);
        },
      };

      return sortValueMap[columnKey]?.() || "";
    },
    [users]
  );

  // Optimized sorting logic with search filter
  const keys = useMemo(() => {
    const searchActive =
      searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH;
    const sourceData = searchActive ? searchResults : data || {};

    const filteredKeys = Object.keys(sourceData);

    // Apply sorting
    const sortedKeys = filteredKeys.sort((a, b) => {
      const aValue = getSortValue(sourceData[a], effectiveSortConfig.key);
      const bValue = getSortValue(sourceData[b], effectiveSortConfig.key);

      const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      return effectiveSortConfig.direction === SORT_DIRECTION.ASC
        ? comparison
        : -comparison;
    });

    return sortedKeys;
  }, [data, effectiveSortConfig, getSortValue, searchTerm, searchResults]);

  const selectedCampaignIDSet = useMemo(
    () => new Set(selectedCampaignIDs),
    [selectedCampaignIDs]
  );

  const getUser = async (userId) => {
    if (!users[userId]) {
      const response = await dispatch(startGetAdsUser(userId));
      if (response) {
        setUsers((prev) => ({ ...prev, [userId]: response }));
      }
    }
  };

  useEffect(() => {
    if (!data) return;
    keys.forEach((key) => {
      if (data[key]?.createdBy) {
        getUser(data[key].createdBy);
      }
    });
    // eslint-disable-next-line
  }, [data]);

  const onDeleteDraftCampaign = async (e, campaignID, campaignData, status) => {
    e?.stopPropagation();
    const isActive = status === ADS_CAMPAIGN_STATUS_ACTIVE;
    const result = await ConfirmAlert({
      title: isActive
        ? t(ALERT_ARCHIVE_CAMPAIGN_TITLE_ACTIVE)
        : t(ALERT_ARCHIVE_CAMPAIGN_TITLE),
      text: t(ALERT_ARCHIVE_CAMPAIGN_DESCRIPTION),
      confirmButtonText: t(BUTTON_ARCHIVE_CAMPAIGN),
    });
    if (!result.isConfirmed) return;
    setIsDeletingCampaign((prev) => ({ ...prev, [campaignID]: true }));

    if (isActive) {
      const response = await onChangeStatusCampaign(campaignID);
      if (!response) {
        setIsDeletingCampaign((prev) => ({ ...prev, [campaignID]: false }));

        return;
      }
    }

    await dispatch(
      startDeleteAdsCampaign(
        getFormattedCampaign({
          data: { ...campaignData, id: campaignID },
          format: "load",
        })
      )
    );
    setIsDeletingCampaign((prev) => ({ ...prev, [campaignID]: false }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        width: { xs: "100%", md: `calc(100vw - ${drawerWidth + 32}px)` },
        transition: widthTransition("width"),
        "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        px: 3,
      }}
    >
      {/* Total cards */}
      <CampaignStatisticsOverview
        dateRange={dateRange}
        folderID={folderID}
        membershipRevision={membershipRevision}
        isLoading={hasActiveDateRange ? !_.isEmpty(statisticsLoading) : false}
        sx={{ mt: 4 }}
      />

      {/* Primera fila: Título + Chip + Filtros */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, sm: 0 },
          mb: -1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6">{t(LIST_TABLE_CAMPAIGNS_TITLE)}</Typography>
          <Chip
            label={`${keys.length} ${
              keys.length === 1 ? t(CAMPAIGN) : t(CAMPAIGNS)
            }`}
            size="small"
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#666",
              fontWeight: 600,
              fontSize: "0.75rem",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            width: { xs: "100%", sm: "auto" },
            justifyContent: { xs: "flex-end", sm: "flex-end" },
          }}
        >
          <SelectUser
            name="createdBy"
            control={control}
            sx={{ mr: 1 }}
            triggerVariant={PILL_TRIGGER_VARIANT.PILL}
            mode="text"
            onGetDisplayText={(field, options) => {
              if (_.isEmpty(field?.value)) {
                return t(FILTER_BY_USERS_PLACEHOLDER);
              }

              const option = options.find(
                (option) => option.value === field.value
              );

              return option?.label || "";
            }}
            showEmptyOption={true}
            emptyOptionText={t(ALL_USERS)}
            startIcon={
              <PersonOutlineIcon
                sx={{ fontSize: 20, color: "text.secondary" }}
              />
            }
          />

          <ColumnVisibilityMenu
            columnVisibility={columnVisibility}
            onToggleColumn={onToggleColumn}
            onSetColumnVisibility={onSetColumnVisibility}
          />
        </Box>
      </Box>

      {folderBar ? (
        <AdsCampaignsFolderBarSticky>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              minWidth: 0,
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>{folderBar}</Box>
            {canEditFolders && selectedCampaignIDs.length > 0 ? (
              <Box sx={{ flexShrink: 0 }}>
                <Button
                  id="ads-campaigns-move-to-folder-selected"
                  color="secondary"
                  iconOnly
                  ariaLabel={t(CAMPAIGNS_FOLDERS_MOVE)}
                  tooltip={t(CAMPAIGNS_FOLDERS_MOVE)}
                  startIcon={<DriveFileMoveIcon sx={{ fontSize: 16 }} />}
                  onClick={onOpenMoveFolder}
                  sx={{
                    height: 32,
                    width: 32,
                    minWidth: 32,
                  }}
                />
              </Box>
            ) : null}
          </Box>
        </AdsCampaignsFolderBarSticky>
      ) : null}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
        }}
      >
        <TextField
          name="searchCampaigns"
          control={searchControl}
          placeholder={t(CAMPAIGNS_SEARCHBAR_PLACEHOLDER)}
          variant="filled"
          fullWidth={false}
          rules={{}}
          actionsChange={(value) => setSearchTerm(value)}
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              boxShadow: BOX_SHADOW_FIELDS,
            },
            "& .MuiInputBase-input": {
              padding: "6px 12px",
            },
          }}
          startIcon={
            <SearchIcon sx={{ color: "#999999 !important", fontSize: 20 }} />
          }
        />
      </Box>

      <TableContainer
        keys={keys}
        emptyText={EMPTY_CAMPAIGNS}
        ariaLabel={t(CAMPAIGNS_TABLE_ARIA_LABEL)}
        hasPagination={false}
        hasMarginBottom={false}
        showEmptyText={false}
        sx={{
          minWidth: isMobile ? "800px" : "100%",
        }}
      >
        <TableHead>
          <TableRow>
            <SortableHeader
              columnKey={SORTABLE_COLUMNS.STATUS}
              isResizable={false}
              sx={{
                width: `${statusColumnWidth}px`,
                minWidth: `${statusColumnWidth}px`,
                maxWidth: `${statusColumnWidth}px`,
                pl: "15px !important",
                pr: "0px !important",
              }}
              isSticky={true}
              stickyPosition="left"
              stickyOffset={0}
            >
              {t(COLUMN_NAME_STATUS)}
            </SortableHeader>
            <TableCell
              {...commonPropsTableCellHeader}
              isResizable={false}
              sx={{
                width: `${alertColumnWidth}px`,
                minWidth: `${alertColumnWidth}px`,
                maxWidth: `${alertColumnWidth}px`,
                px: "0px !important",
                textAlign: "center",
              }}
              isSticky={true}
              stickyPosition="left"
              stickyOffset={statusColumnWidth}
            >
              {/* Columna vacía para el icono de alerta */}
            </TableCell>
            <TableCell
              {...commonPropsTableCellHeader}
              sx={{
                pl: "16px !important",
                minWidth: loading ? 274 : 250,
                width: 250,
                maxWidth: 250,
              }}
              isSticky={true}
              stickyPosition="left"
              stickyOffset={statusColumnWidth + alertColumnWidth}
            >
              {t(COLUMN_NAME_CAMPAIGN)}
            </TableCell>
            <TableCell
              {...commonPropsTableCellHeader}
              sx={{ minWidth: "120px" }}
            >
              {t(COLUMN_NAME_PLATFORM)}
            </TableCell>
            {columnVisibility.impressions && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.IMPRESSIONS}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_IMPRESSIONS)}
              </SortableHeader>
            )}
            {columnVisibility.clicks && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.CLICKS}
                sx={{ minWidth: "100px" }}
              >
                {t(COLUMN_NAME_CLICKS)}
              </SortableHeader>
            )}
            {columnVisibility.ctr && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.CTR}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_CTR)}
              </SortableHeader>
            )}
            {columnVisibility.spend && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.SPEND}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_SPEND)}
              </SortableHeader>
            )}
            {columnVisibility.roas && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.ROAS}
                sx={{ minWidth: "120px" }}
              >
                {t(ROAS_METRICS)}
              </SortableHeader>
            )}
            {columnVisibility.cpm && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.CPM}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_CPM)}
              </SortableHeader>
            )}
            {columnVisibility.cpc && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.CPC}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_CPC)}
              </SortableHeader>
            )}
            {columnVisibility.results && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.RESULTS}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_RESULTS)}
              </SortableHeader>
            )}
            {columnVisibility.cpa && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.CPA}
                sx={{ minWidth: "120px" }}
              >
                {t(COLUMN_NAME_CPA)}
              </SortableHeader>
            )}
            {columnVisibility.frequency && (
              <SortableHeader
                columnKey={SORTABLE_COLUMNS.FREQUENCY}
                sx={{ minWidth: "120px" }}
              >
                {t(FREQUENCY)}
              </SortableHeader>
            )}

            <TableCell
              {...commonPropsTableCellHeader}
              sx={{ minWidth: "150px" }}
            >
              {t(COLUMN_NAME_CREATED_BY)}
            </TableCell>
            <SortableHeader
              columnKey={SORTABLE_COLUMNS.CREATION_TIME}
              sx={{ minWidth: "150px" }}
            >
              {t(COLUMN_NAME_CREATED_DATE)}
            </SortableHeader>
            <TableCell
              {...commonPropsTableCellHeader}
              isResizable={false}
              sx={{ minWidth: 120, pl: "15px !important" }}
            >
              {t(COLUMN_NAME_ACTIONS)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(loading || isSearching) && (
            <TableRow>
              <TableCell colSpan={18} align="center">
                <Loader size={24} hasMarginTop={false} />
              </TableCell>
            </TableRow>
          )}
          {!loading &&
            !isSearching &&
            keys.length === 0 &&
            searchTerm &&
            searchTerm.length >= MIN_LENGTH_TO_SEARCH && (
              <TableRow>
                <TableCell colSpan={18} align="center">
                  <Typography variant="body2" color="text.secondary">
                    {t(CAMPAIGNS_NOT_FOUND)}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          {!loading &&
            !isSearching &&
            keys.length === 0 &&
            !(searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH) && (
              <TableRow>
                <TableCell colSpan={18} align="center">
                  <Typography variant="body2" color="text.secondary">
                    {t(folderID ? CAMPAIGNS_FOLDER_EMPTY : EMPTY_CAMPAIGNS)}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          {!loading &&
            !isSearching &&
            keys.length > 0 &&
            true &&
            keys.map((row, index) => {
              const searchActive =
                searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH;
              const sourceData = searchActive ? searchResults : data || {};
              const campaign = sourceData[row];
              if (!campaign) {
                return null;
              }
              const campaignID = campaign.id || row;
              const status = getStatusAdsCampaign({
                states: campaign.states,
                target: "general",
              });
              const user = users[campaign.createdBy];
              const isLoadingStatistics =
                statisticsLoading.includes(campaignID);
              const isSyncing = syncingCampaignIDs.includes(campaignID);
              const isLastRow = index === keys.length - 1;
              const isSelected = selectedCampaignIDSet.has(campaignID);

              const isTreeOpen = Boolean(expandedCampaignTrees[campaignID]);
              const campaignRowIsLast = isLastRow && !isTreeOpen;

              return (
                <Fragment key={campaignID}>
                  <TableRow
                    hover
                    aria-selected={isSelected}
                    draggable={canEditFolders}
                    onDragStart={(event) => {
                      event.dataTransfer.setData("text/plain", campaignID);
                      if (isSelected && selectedCampaignIDs.length > 1) {
                        event.dataTransfer.setData(
                          GALLERY_DRAG_MIME_SELECTED,
                          "1"
                        );
                      }
                      event.dataTransfer.effectAllowed = "move";
                    }}
                    onClick={(event) => {
                      if (event.defaultPrevented) return;
                      if (event.ctrlKey || event.metaKey) {
                        event.preventDefault();
                        onToggleCampaignSelection(campaignID);
                        return;
                      }
                      navigate(
                        buildCampaignEditorPath({
                          campaignID,
                          platform: campaign.platforms?.[0],
                        })
                      );
                    }}
                    sx={{
                      cursor: canEditFolders ? "grab" : "pointer",
                      userSelect: canEditFolders ? "none" : "auto",
                      "& td": {
                        backgroundColor: isSelected
                          ? "#e6e6e6 !important"
                          : undefined,
                        transition: "background-color 80ms ease",
                      },
                      "&:hover td": {
                        backgroundColor: isSelected
                          ? "#d9d9d9 !important"
                          : "#f0f0f0 !important",
                      },
                    }}
                  >
                    <TableCell
                      {...commonPropsTableCellBody}
                      showTooltip={false}
                      isLastRow={campaignRowIsLast}
                      isSticky={true}
                      stickyPosition="left"
                      stickyOffset={0}
                      sx={{
                        width: `${statusColumnWidth}px`,
                        minWidth: `${statusColumnWidth}px`,
                        maxWidth: `${statusColumnWidth}px`,
                        pl: "12px !important",
                        pr: "0px !important",
                        overflow: "visible",
                        zIndex: 1001,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.75,
                        }}
                      >
                        <StatusSwitch
                          status={status}
                          active={status === ADS_CAMPAIGN_STATUS_ACTIVE}
                          readOnly={!canEditCampaign}
                          onChangeStatus={async () => {
                            await onChangeStatusCampaign(row);
                          }}
                        />
                        {isSyncing && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.75,
                              pl: 0.5,
                              minWidth: 0,
                              mt: 0.25,
                            }}
                          >
                            <Loader size={15} hasMarginTop={false} />
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell
                      {...commonPropsTableCellBody}
                      showTooltip={false}
                      isLastRow={campaignRowIsLast}
                      isSticky={true}
                      stickyPosition="left"
                      stickyOffset={statusColumnWidth}
                      sx={{
                        width: `${alertColumnWidth}px`,
                        minWidth: `${alertColumnWidth}px`,
                        maxWidth: `${alertColumnWidth}px`,
                        px: "0px !important",
                        textAlign: "center",
                      }}
                    >
                      <AlertIcon
                        platformsData={campaign.platformsData}
                        platforms={campaign.platforms}
                        states={campaign.states}
                        itemStatuses={alertItemStatuses}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        pl: "16px !important",
                        minWidth: 250,
                        width: 250,
                        maxWidth: 250,
                      }}
                      sxContainerTooltip={{
                        minWidth: 250,
                        width: 250,
                        maxWidth: 250,
                      }}
                      {...commonPropsTableCellBody}
                      isLastRow={campaignRowIsLast}
                      isSticky={true}
                      stickyPosition="left"
                      stickyOffset={statusColumnWidth + alertColumnWidth}
                      showTooltip={false}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          minWidth: 0,
                        }}
                      >
                        <CampaignTableExpandButton
                          expanded={isTreeOpen}
                          expandLabel={t(CAMPAIGNS_TABLE_EXPAND_ROW)}
                          collapseLabel={t(CAMPAIGNS_TABLE_COLLAPSE_ROW)}
                          onToggle={() => onToggleCampaignTree({ campaignID })}
                        />
                        <Typography
                          variant="bod2"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {campaign?.platformsData?.[campaign?.platforms?.[0]]
                            ?.name || campaign.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell
                      {...commonPropsTableCellBody}
                      isLastRow={campaignRowIsLast}
                      showTooltip={false}
                    >
                      <PlatformsItem platforms={campaign.platforms} />
                    </TableCell>
                    {columnVisibility.impressions && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="impressions"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="impressions"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.clicks && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="clicks"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="clicks"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.ctr && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="ctr"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="ctr"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.spend && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="spend"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="spend"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.roas && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="roas"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="roas"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.cpm && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="cpm"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="cpm"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}

                    {columnVisibility.cpc && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="cpc"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="cpc"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.results && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="mainAction"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="mainAction"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.cpa && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="cpa"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="cpa"
                          isLoading={statisticsLoading.includes(campaignID)}
                        />
                      </TableCell>
                    )}
                    {columnVisibility.frequency && (
                      <TableCell
                        {...commonPropsTableCellBody}
                        isLastRow={campaignRowIsLast}
                        tooltipComponent={
                          <CampaignMetric
                            campaign={campaign}
                            type="frequency"
                            isLoading={isLoadingStatistics}
                            applyFormat={false}
                          />
                        }
                      >
                        <CampaignMetric
                          campaign={campaign}
                          type="frequency"
                          isLoading={isLoadingStatistics}
                        />
                      </TableCell>
                    )}
                    <TableCell
                      {...commonPropsTableCellBody}
                      isLastRow={campaignRowIsLast}
                      showTooltip={false}
                    >
                      {user?.name || t(LOADING)}
                    </TableCell>
                    <TableCell
                      {...commonPropsTableCellBody}
                      isLastRow={campaignRowIsLast}
                      showTooltip={false}
                    >
                      {campaign.creationTime &&
                        t(DATE_SHORT_2, {
                          date: new Date(campaign.creationTime),
                        })}
                    </TableCell>
                    <TableCell
                      {...commonPropsTableCellBody}
                      showTooltip={false}
                      isLastRow={campaignRowIsLast}
                    >
                      <CampaignActions
                        campaign={campaign}
                        canEditCampaign={canEditCampaign}
                        canCreateCampaign={canCreateCampaign}
                        isDeletingCampaign={isDeletingCampaign[row]}
                        onDelete={(e) =>
                          onDeleteDraftCampaign(e, row, campaign, status)
                        }
                        folderID={folderID}
                        onRemoveFromFolder={(e) => {
                          e?.stopPropagation();
                          onRemoveFromFolder({ campaignIDs: [row] });
                        }}
                      />
                    </TableCell>
                  </TableRow>
                  {isTreeOpen ? (
                    <CampaignTableTreeRows
                      campaignID={campaignID}
                      entry={campaignTreeEntries[campaignID]}
                      columnVisibility={columnVisibility}
                      statusColumnWidth={statusColumnWidth}
                      alertColumnWidth={alertColumnWidth}
                      canEditCampaign={canEditCampaign}
                      isLastRow={campaignRowIsLast}
                      creatorName={user?.name || null}
                      onRetry={onRetryCampaignTree}
                      onChangeEntityStatus={onChangeEntityStatus}
                    />
                  ) : null}
                </Fragment>
              );
            })}
          {/* Fila de carga - aparece cuando hay más campañas por cargar */}
          {!loadedLastCampaign &&
            !loading &&
            !(searchTerm && searchTerm.length >= MIN_LENGTH_TO_SEARCH) &&
            !isSearching && (
              <TableRow
                ref={lastItemRef}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <TableCell
                  colSpan={18}
                  align="center"
                  sx={{
                    height: "80px !important",
                    padding: "20px !important",
                    border: "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Loader size={24} hasMarginTop={false} />
                  </Box>
                </TableCell>
              </TableRow>
            )}
        </TableBody>
      </TableContainer>
    </Box>
  );
};

const PlatformsItem = ({ platforms }) => (
  <Box
    sx={{
      display: "flex",
    }}
  >
    <Box sx={{ display: "flex", gap: 1 }}>
      {platforms?.map((platform) => (
        <Avatar
          key={platform}
          src={logoPlatform(platform)}
          alt={`${platform} Logo`}
          variant="square"
          sx={{
            width: platform === META ? 25 : 20,
            height: "auto",
            ".MuiAvatar-img": { objectFit: "contain" },
          }}
        />
      ))}
    </Box>
  </Box>
);

const CampaignActions = ({
  campaign,
  canEditCampaign,
  canCreateCampaign,
  isDeletingCampaign,
  onDelete,
  folderID = null,
  onRemoveFromFolder,
}) => {
  const { t } = useTranslationApp();
  const {
    label: deleteLabel,
    Icon: DeleteActionIcon,
    onAction: onDeleteAction,
    isRemoveFromFolder,
  } = useFolderAwareDeleteAction({
    activeFolderID: folderID,
    deleteLabel: t(BUTTON_ARCHIVE_CAMPAIGN),
    deleteIcon: DeleteOutlineIcon,
    onDelete,
    onRemoveFromFolder,
  });

  const status = getStatusAdsCampaign({
    states: campaign.states,
    target: "general",
  });
  const canShowReports = status !== ADS_CAMPAIGN_STATUS_DRAFT;
  const canShowDuplicateButton = canEditCampaign || canCreateCampaign;

  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="flex-start"
      alignItems="center"
    >
      {canEditCampaign && (
        <>
          {isDeletingCampaign && !isRemoveFromFolder ? (
            <Loader size={20} hasMarginTop={false} />
          ) : (
            <Tooltip title={deleteLabel} arrow>
              <IconButton
                size="small"
                aria-label={deleteLabel}
                onClick={onDeleteAction}
                sx={{
                  color: "background.paperContrastText",
                  width: 32,
                  height: 32,
                }}
              >
                <DeleteActionIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}

      {canShowDuplicateButton && (
        <ButtonDuplicateCampaign
          campaignID={campaign.id}
          mode="icon"
          sx={{
            width: 20,
            height: 20,
            color: "background.paperContrastText",
          }}
        />
      )}

      {canShowReports && (
        <Tooltip title={t(REPORTS)} arrow>
          <IconButton
            size="small"
            onClick={(e) => {
              e?.stopPropagation();
              openLink(`/ads-campaign-statistics?campaignID=${campaign.id}`);
            }}
            sx={{
              color: "background.paperContrastText",
              width: 32,
              height: 32,
            }}
          >
            <ChartColumnBig />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

const CampaignMetric = ({
  campaign,
  type,
  isLoading = false,
  applyFormat = true,
}) => {
  const dispatch = useDispatchApp();
  const { t } = useTranslationApp();
  const statistics = campaign.statistics || {};
  const status = getStatusAdsCampaign({
    states: campaign.states,
    target: "general",
  });
  const hasMetrics = !_.isEmpty(statistics);
  const isCampaignDraft = status === ADS_CAMPAIGN_STATUS_DRAFT;
  const generalStatistics = getGeneralStatistics(statistics);

  if (isLoading) {
    return <SkeletonCampaignMetric />;
  }

  if (isCampaignDraft) return "-";
  if (status !== ADS_CAMPAIGN_STATUS_ACTIVE && !generalStatistics.impressions)
    return "-";
  if (!hasMetrics || !generalStatistics.impressions) return "-";

  const platforms = Object.keys(statistics || {}).filter(
    (platform) => platform !== "total"
  );
  const currenciesPlatform = {};
  const currencies = [];
  platforms.forEach((platform) => {
    const platformData = campaign?.platformsData?.[platform] || {};
    if (_.isEmpty(platformData)) return;
    const currency = dispatch(
      getCurrencyAdAccountPlatform({
        platform,
        integrationID: platformData?.integrationID,
        adAccountID: platformData?.adAccountID,
      })
    );
    if (!currency) return;
    currenciesPlatform[platform] = currency;
    if (!currencies.includes(currency)) {
      currencies.push(currency);
    }
  });

  const hasUniqueCurrency = currencies.length === 1;

  const formatValue = (value) => {
    if (applyFormat) {
      return numberCompactFormat(value);
    }
    if (Number(value) % 1 !== 0) {
      // Value is a decimal
      return value.toFixed(2);
    }
    return t(VALUE_NUMBER, { value });
  };

  const renderCPAValue = () => {
    const generalCPA = generalStatistics?.costPerMainAction;

    if (hasUniqueCurrency) {
      if (!generalCPA) {
        return "-";
      }

      return <>{`${formatValue(generalCPA)} ${currencies[0]}`}</>;
    }

    const platformsWithCPA = Object.keys(currenciesPlatform).filter(
      (platform) => {
        const platformCPA = statistics?.[platform]?.costPerMainAction;
        return platformCPA != null && Number(platformCPA) !== 0;
      }
    );

    if (!platformsWithCPA.length) {
      return "-";
    }

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {platformsWithCPA.map((platform) => (
          <Box
            key={getUniqueID()}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 1,
            }}
          >
            <Avatar
              src={logoPlatform(platform)}
              variant="square"
              alt={platform}
              sx={{
                // Conditionals for META because it is wider
                width: platform === META ? 21 : 20,
                pl: platform === META ? 0 : 0.25,
                height: "auto",
                ".MuiAvatar-img": { objectFit: "contain" },
              }}
            />
            <CellTypography
              sx={{
                whiteSpace: "nowrap",
                position: "relative",
                top: "1px",
              }}
            >
              {`${formatValue(
                statistics?.[platform]?.costPerMainAction
              )} ${currenciesPlatform[platform]}`}
            </CellTypography>
          </Box>
        ))}
      </Box>
    );
  };

  const renderValue = () => {
    const hasMainAction = Number(generalStatistics?.mainAction) > 0;
    switch (type) {
      case "mainAction":
        return (
          <>{hasMainAction ? formatValue(generalStatistics.mainAction) : "-"}</>
        );
      case "clicks":
        return (
          <>
            {generalStatistics.click
              ? formatValue(generalStatistics.click)
              : "-"}
          </>
        );
      case "ctr":
        return (
          <>
            {generalStatistics.ctr
              ? `${formatValue(generalStatistics.ctr)}%`
              : "-"}
          </>
        );
      case "impressions":
        return (
          <Tooltip title={generalStatistics.impressions}>
            <>
              {generalStatistics.impressions
                ? formatValue(generalStatistics.impressions)
                : "-"}
            </>
          </Tooltip>
        );
      case "cpc":
        return (
          <>
            {generalStatistics.cpc ? formatValue(generalStatistics.cpc) : "-"}
          </>
        );
      case "cpm":
        return (
          <>
            {generalStatistics.cpm ? formatValue(generalStatistics.cpm) : "-"}
          </>
        );
      case "cpa":
        return renderCPAValue();
      case "frequency":
        return (
          <>
            {generalStatistics.frequency
              ? formatValue(generalStatistics.frequency)
              : "-"}
          </>
        );
      case "spend":
        return (
          <>
            {hasUniqueCurrency && (
              <>{`${formatValue(generalStatistics.spend)} ${currencies[0]}`}</>
            )}
            {!hasUniqueCurrency && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {Object.keys(currenciesPlatform).map((platform) => (
                  <Box
                    key={getUniqueID()}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Avatar
                      src={logoPlatform(platform)}
                      variant="square"
                      alt={platform}
                      sx={{
                        // Conditionals for META because it is wider
                        width: platform === META ? 21 : 20,
                        pl: platform === META ? 0 : 0.25,
                        height: "auto",
                        ".MuiAvatar-img": { objectFit: "contain" },
                      }}
                    />
                    <CellTypography
                      sx={{
                        whiteSpace: "nowrap",
                        position: "relative",
                        top: "1px",
                      }}
                    >
                      {`${formatValue(statistics?.[platform]?.spend)} ${currenciesPlatform[platform]}`}
                    </CellTypography>
                  </Box>
                ))}
              </Box>
            )}
          </>
        );
      case "roas":
        return Number(generalStatistics.roas) > 0 ? (
          <>{`${numberDecimal(Number(generalStatistics.roas))}x`}</>
        ) : (
          "-"
        );
      default:
        return "-";
    }
  };

  return renderValue();
};

const AlertIcon = ({ platformsData, platforms, states, itemStatuses = {} }) => {
  const { t } = useTranslationApp();

  const allAlerts = [];

  if (platforms && platformsData) {
    platforms.forEach((platform) => {
      const platformData = platformsData[platform];

      if (platformData?.alerts && platformData.alerts.length > 0) {
        const alertsByType = new Map();

        platformData.alerts.forEach((alert) => {
          if (!alert.type || !isVisibleCreativeFatigueAlert(alert)) {
            return;
          }
          if (
            !isAlertForActiveItem({
              alert,
              platform,
              states,
              itemStatuses,
            })
          ) {
            return;
          }

          const existing = alertsByType.get(alert.type);
          if (existing && alert.type === CREATIVE_FATIGUE_ALERT_TYPE) {
            const rank = {
              [CREATIVE_FATIGUE_LEVELS.MEDIUM]: 1,
              [CREATIVE_FATIGUE_LEVELS.HIGH]: 2,
            };
            const existingRank = rank[existing.level] || 0;
            const nextRank = rank[getCreativeFatigueLevel(alert)] || 0;
            if (nextRank <= existingRank) {
              return;
            }
          } else if (existing) {
            return;
          }

          alertsByType.set(alert.type, {
            platform: platform,
            alertType: alert.type,
            level: getCreativeFatigueLevel(alert),
            longMessage: alert.longMessage,
            shortMessage: alert.shortMessage,
            cpa: alert.cpa,
            targetCpa: alert.targetCpa,
            currency: alert.currency,
          });
        });

        alertsByType.forEach((alertData) => {
          allAlerts.push(alertData);
        });
      }
    });
  }

  const renderKpiTargetCpaAlert = (alert) => (
    <Trans
      i18nKey={KPI_TARGET_CPA_ABOVE_PLATFORM}
      values={{
        platform: t(alert.platform),
        cpa: numberMetricFormat(alert.cpa),
        targetCpa: numberMetricFormat(alert.targetCpa),
        currency: alert.currency,
      }}
      components={{
        bold: <Box component="span" sx={{ fontWeight: 700 }} />,
      }}
    />
  );

  const getAlertMessage = (alert) => {
    switch (alert.alertType) {
      case "ALERT_DISAPPROVALS_ISSUES":
        return alert.longMessage || alert.shortMessage || "";
      case ALERTS_CAMPAIGNS.ALERT_CAMPAIGN_CPA_HIGH:
        return "kpi-target-cpa";
      case CREATIVE_FATIGUE_ALERT_TYPE: {
        const messageKey = getCampaignAlertMessage(alert, { variant: "table" });
        return messageKey ? t(messageKey) : "";
      }
      default: {
        const alertTranslation = ALERTS_CAMPAIGNS_TEXT_TABLE[alert.alertType]
          ? t(ALERTS_CAMPAIGNS_TEXT_TABLE[alert.alertType], {
              platform: t(alert.platform),
            })
          : null;

        return (
          alertTranslation?.trim() ||
          alert.shortMessage ||
          alert.longMessage ||
          ""
        );
      }
    }
  };

  const alertsWithMessages = allAlerts.filter((alert) => {
    const message = getAlertMessage(alert);
    return message;
  });

  const isErrorAlert = alertsWithMessages.some(
    (alert) => !YELLOW_ALERT_TYPES.includes(alert.alertType)
  );

  const iconColor = isErrorAlert ? ALERT_COLORS.error : ALERT_COLORS.yellow;

  if (alertsWithMessages.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Tooltip
        title={
          <Box>
            {alertsWithMessages.map((item, index) => (
              <Typography
                key={`${item.platform}-${item.alertType}-${index}`}
                sx={{ fontSize: "0.875rem", color: "white" }}
                variant="body2"
              >
                {item.alertType === ALERTS_CAMPAIGNS.ALERT_CAMPAIGN_CPA_HIGH
                  ? renderKpiTargetCpaAlert(item)
                  : `${
                      item.platform.charAt(0).toUpperCase() +
                      item.platform.slice(1)
                    }: ${getAlertMessage(item)}`}
              </Typography>
            ))}
          </Box>
        }
        arrow
      >
        <Box
          sx={{
            width: 18,
            height: 18,
            borderRadius: "50%",
            backgroundColor: iconColor.background,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="span"
            sx={{
              color: "#ffffff",
              fontSize: "0.75rem",
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            !
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export { CampaignMetric, StatusSwitch, PlatformsItem };

export default AdsCampaignsTable;
